import createCachedSelector from 're-reselect';

import type { CampaignSponsors, EntityStatus, User, YammerState } from '../../state/types';
import { getStatusForId } from '../../state/types';
import { createFindById, createFindByIdThrows } from '../findById';
import { findUsers } from '../users/selectors';

type GetStatusForCampaignSponsorsId = (state: YammerState, campaignId: CampaignSponsors['id']) => EntityStatus;
export const getStatusForCampaignSponsorsId: GetStatusForCampaignSponsorsId = (state, campaignId) =>
  getStatusForId(state.campaignSponsors, campaignId);

export const findCampaignSponsorsById = createFindById('campaignSponsors');
export const findCampaignSponsorsByIdThrows = createFindByIdThrows('campaignSponsors');

type GetCampaignSponsors = (state: YammerState, campaignId: CampaignSponsors['id']) => User['id'][] | undefined;
export const getCampaignSponsors: GetCampaignSponsors = createCachedSelector(
  (_state: YammerState, campaignId: CampaignSponsors['id']) => campaignId,
  findCampaignSponsorsById,
  (_campaignId, campaignSponsors) => campaignSponsors?.users.map((sponsor) => sponsor.nodeId)
)((_state, campaignId) => campaignId);

type GetCampaignSponsorsThrows = (state: YammerState, campaignId: CampaignSponsors['id']) => User['id'][];
export const getCampaignSponsorsThrows: GetCampaignSponsorsThrows = createCachedSelector(
  (_state: YammerState, campaignId: CampaignSponsors['id']) => campaignId,
  findCampaignSponsorsByIdThrows,
  (_campaignId, campaignSponsors) => campaignSponsors.users.map((sponsor) => sponsor.nodeId)
)((_state, campaignId) => campaignId);

type GetCampaignSponsorUsersThrows = (state: YammerState, campaignId: CampaignSponsors['id']) => User[];
export const getCampaignSponsorUsersThrows: GetCampaignSponsorUsersThrows = (state, campaignId) => {
  const userIds = getCampaignSponsorsThrows(state, campaignId);

  return findUsers(state, userIds);
};
